import {MotorClassList} from "./MotorClassList";
import {MotorClassEdit} from "./MotorClassEdit";
import {MotorClassCreate} from "./MotorClassCreate";

export default {
    list: MotorClassList,
    create: MotorClassCreate,
    edit: MotorClassEdit
};
